console.log("development - ", process.env.NODE_ENV === "development")
export default {
    serverURL: process.env.REACT_APP_SERVER_URL, //"https://api.yestextme.com",
    development: process.env.NODE_ENV === "development",
    version: process.env.REACT_APP_VERSION,
    defaultTimeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
    vaccinationTimeout: process.env.REACT_APP_VACCINATION_TIMEOUT,
}
